<template>
  <div class="p-override-calendar" @date-select="$emit('update:modelValue', $event)">
    <p-vue-calendar v-bind="$attrs" />
    <i-icon name="arrow" />
  </div>
</template>

<style scoped>

  .p-override-calendar {
    position: relative;
  }

  .p-override-calendar:deep(.svg--arrow) {
    top: 50%;
    left: 10px;
    position: absolute;
    transform: translateY(-50%);

    width: 15px;
    height: 15px;

    color: var(--color-success);

    transition: transform .3s ease;
  }

  .p-override-calendar:deep(.p-calendar) {
    width: 100%;
  }

</style>